import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import HeadsetIcon from '@material-ui/icons/Headset';
import BluetoothConnectedIcon from '@material-ui/icons/BluetoothConnected';
import ReplayIcon from '@material-ui/icons/Replay';
import TuneIcon from '@material-ui/icons/Tune';

import { navigatorDetails } from 'UTILS/navigator';

export const getSpeakersSelectionSupportLink = ({ os = navigatorDetails.os, locale } = {}) => {
  switch (os) {
    case 'MacOS':
      return 'speakersSelectionSupportMacOSLink';
    case 'Windows':
      return 'speakersSelectionSupportWindowsLink';
    case 'Linux':
      return 'speakersSelectionSupportLinuxLink';
  }
};

export const getSpeakersHintList = ({ os = navigatorDetails.os } = {}) => {
  const hintList = [];
  if (['Windows', 'MacOS', 'Linux'].includes(os)) {
    hintList.push({
      icon: TuneIcon,
      title: 'selectTheRightAudioOutput',
      text: 'changeTheAudioOutputByGoingToTheAudioSettingsOf',
      buttonList: [{
        href: getSpeakersSelectionSupportLink(),
        label: 'stepByStep',
      }],
    });
  }
  return hintList;
};

export const SPEAKERS_RESULT_MAP = {
  'tone_not_heard': {
    message: 'toneNotHeard',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: VolumeUpIcon,
        title: 'increaseTheVolume',
        text: 'increaseTheVolumeOfYourSpeakersAndRunTheCheckAgain',
      },
      {
        icon: BluetoothConnectedIcon,
        title: 'checkTheBluetoothDevices',
        text: 'ifYouHaveABluetoothDeviceThatIsConnectedCheckIfSoundComesOutOfIt',
      },
      {
        icon: HeadsetIcon,
        title: 'checkTheJackOutput',
        text: 'ifYouHaveADeviceThatIsConnectedOnAJackPlugCheckIfSoundComesOutOfIt',
      },
      ...getSpeakersHintList(),
    ],
  },
  'not_allowed': {
    message: 'browserCantAccessSpeakers',
    title: 'howCanIFixIt',
    hintList: [
      {
        icon: ReplayIcon,
        title: 'retry',
        text: 'theBrowserMightJusteNeedYouToRetry',
      },
    ],
  },
  'tone_heard': {
    message: 'workingSpeakers',
  },
};
